import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { GruppiTipiDannoComponent } from '../../../../admin/gruppi-tipi-danno/gruppi-tipi-danno.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => GruppoTipiDannoPickerComponent) },
  ],
  selector: 'gruppo-tipi-danno-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class GruppoTipiDannoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(GruppiTipiDannoComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
